import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import {
  CreateTick,
  RebookersCommission,
  FlatFee,
  NumBookings,
  TenancyLength,
} from 'common/components/svgs';
import { commissionCategories } from '~constants/commission';
import showElementByAuth from '~helpers/auth';
import { platformEntity, entityAction, commissionLevel as commissionLevelConst } from '~constants';

const CreateCommission = ({
  t,
  commissionLevel,
  commissionCategory,
  changeCommissionCategory,
  createCommission,
}) => {
  const choiceSvg = (type, className) => {
    switch (type) {
      case 'REBOOKERS_COMMISSION':
        return <RebookersCommission className={className} />;

      case 'FLAT_FEE':
        return <FlatFee className={className} />;

      case 'NUM_BOOKINGS':
        return <NumBookings className={className} />;

      case 'TENANCY_LENGTH':
        return <TenancyLength className={className} />;

      default:
        return 'div';
    }
  };

  return (
    <div className="property-commission__content">
      <div className="property-commission__commission-type">
        <span className="property-commission__type-label">
          {t('cms.property.commission.create.commission_type')}
        </span>
        <div className="property-commission__type-items">
          <For each="item" of={commissionCategories} index="index">
            <div className="property-commission__type-card" key={item}>
              <div
                role="button"
                tabIndex={0}
                onClick={() => changeCommissionCategory(item)}
                className={classNames('property-commission__type-item', {
                  'property-commission__type-item--check': commissionCategory === item,
                })}
              >
                {choiceSvg(item, 'property-commission__type-icon')}

                <If condition={commissionCategory === item}>
                  <span className="property-commission__type-tick">
                    <CreateTick className="property-commission__check-icon" />
                  </span>
                </If>
              </div>
              <span className="property-commission__type-text">
                {t(`cms.property.commission.create.commission_type.${item.toLowerCase()}`)}
              </span>
            </div>
          </For>
        </div>
      </div>

      <If
        condition={showElementByAuth(
          platformEntity.COMMISSION_COMISSION_TIERS,
          entityAction.CREATE,
        )}
      >
        <div className="property-commission__create-btn">
          <If condition={commissionLevel === commissionLevelConst.PROPERTY}>
            <Button type="primary" onClick={createCommission} className="property-commission__btn">
              {t('cms.property.commission.create.create_commission.btn')}
            </Button>
            <span className="property-commission__create-tips">
              {t('cms.property.commission.create.create_commission.tips')}
            </span>
          </If>
          <If condition={commissionLevel === commissionLevelConst.LANDLORD}>
            <Button type="primary" onClick={createCommission} className="property-commission__btn">
              <PlusOutlined />
              {t('cms.landlord.commission.create.create_btn')}
            </Button>
          </If>
        </div>
      </If>
    </div>
  );
};

CreateCommission.propTypes = {
  t: PropTypes.func,
  commissionCategory: PropTypes.string,
  changeCommissionCategory: PropTypes.func,
  createCommission: PropTypes.func,
};

CreateCommission.defaultProps = {
  t: () => {},
  commissionCategory: '',
  changeCommissionCategory: () => {},
  createCommission: () => {},
};

export default CreateCommission;
